import { SvgIconType } from './svg.interface';

const Reload: SvgIconType = ({
  width = 12,
  height = 12,
  color = '#FFFFFF',
  className = ''
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.26084 4.19307V2.09907C9.62867 2.895 10.5002 4.36575 10.5002 5.99466C10.5002 8.00593 9.17981 9.75381 7.2874 10.3143C6.89021 10.4319 6.66349 10.8495 6.78102 11.2471C6.89855 11.6446 7.31581 11.8715 7.713 11.7539C10.2392 11.0057 12.0002 8.67462 12.0002 5.99466C12.0002 4.23722 11.2389 2.61749 9.98203 1.50133H10.9502C11.3644 1.50133 11.7002 1.16525 11.7002 0.750667C11.7002 0.336085 11.3644 0 10.9502 0H7.51084C7.3189 0 7.12696 0.0732884 6.98051 0.219865C6.83406 0.366442 6.76084 0.558555 6.76084 0.750667V4.19307C6.76084 4.60765 7.09662 4.94373 7.51084 4.94373C7.92505 4.94373 8.26084 4.60765 8.26084 4.19307Z"
      fill={color}
    />
    <path
      d="M3.73936 7.80693V9.90093C2.37152 9.105 1.5 7.63424 1.5 6.00534C1.5 3.99407 2.82039 2.24619 4.7128 1.68574C5.10999 1.56811 5.3367 1.15048 5.21918 0.752934C5.10165 0.35539 4.68439 0.128476 4.2872 0.246106C1.76098 0.994264 0 3.32538 0 6.00534C0 7.76278 0.761315 9.38251 2.01816 10.4987H1.05002C0.635805 10.4987 0.300018 10.8348 0.300018 11.2493C0.300018 11.6639 0.635805 12 1.05002 12H4.48936C4.6813 12 4.87324 11.9267 5.01969 11.7801C5.16613 11.6336 5.23936 11.4414 5.23936 11.2493V7.80693C5.23936 7.39235 4.90357 7.05627 4.48936 7.05627C4.07514 7.05627 3.73936 7.39235 3.73936 7.80693Z"
      fill={color}
    />
  </svg>
);

export default Reload;
